// extracted by mini-css-extract-plugin
export default {"container":"NameEditor_container__o4M2N","input":"NameEditor_input__Xqj1W"};